import { UpdateUserLanguageArgs } from 'types/api/arguments/update-user-language-args'

import { api } from './api'

export const updateUserLanguage = ({ userId, locale }: UpdateUserLanguageArgs) =>
  api.put(`users/${userId}/language_settings/?locale=${locale}`)
